import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class PurchaseReceiptDateEarlierThanIssueDateError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.purchase.validation.recepit-date-earlier-than-issue-date-error.message');
    }
}
